import type { Maybe } from '@adornis/base/utilTypes';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Base } from '@adornis/buildify/db/Base.js';
import type { SupportTopic } from '../../../formulars/_support-form/db/enums';

@Entity()
export class DubniumBaseSupportFormular extends Base {
  static override _class = 'DubniumBaseSupportFormular';

  @Field(type => String)
  topic?: Maybe<SupportTopic>;

  @Field(type => String)
  productID?: Maybe<SupportTopic>;
}
